<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md8>
				<v-layout row wrap>
					<v-flex xs12 md12>
						<ValidationProvider name="name" v-slot="{ errors, valid }">
							<form-localized-input v-model="item.name" :errors="errors" :valid="valid">
							</form-localized-input>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider name="code" rules="required" v-slot="{ errors }">
							<v-text-field type="number" v-model="item.code" :label="$t('Code')" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider name="bonus" rules="required" v-slot="{ errors }">
							<v-text-field type="number" v-model="item.bonus" :label="$t('label.bonus')" :error-messages="errors" :suffix="'Pts'"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider name="price" rules="required" v-slot="{ errors }">
							<v-text-field type="number" v-model="item.price" :label="$t('Price')" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider name="signup_fee" rules="required" v-slot="{ errors }">
							<v-text-field type="number" v-model="item.signup_fee" :label="$t('label.signup_fee')" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider name="invoice_period" rules="required" v-slot="{ errors }">
							<v-text-field type="number" v-model="item.invoice_period" :label="$t('label.invoice_period')" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider name="invoice_interval" v-slot="{ errors }">
							<v-select v-model="item.invoice_interval" :label="$t('label.invoice_interval')" :items="invoice_intervals" :error-messages="errors"></v-select>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider name="trial_period" rules="required" v-slot="{ errors }">
							<v-text-field type="number" v-model="item.trial_period" :label="$t('label.trial_period')" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider name="trial_interval" v-slot="{ errors }">
							<v-select v-model="item.trial_interval" :label="$t('label.trial_interval')" :items="invoice_intervals" :error-messages="errors"></v-select>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider name="grace_period" rules="required" v-slot="{ errors }">
							<v-text-field type="number" v-model="item.grace_period" :label="$t('label.grace_period')" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider name="grace_interval" v-slot="{ errors }">
							<v-select v-model="item.grace_interval" :label="$t('label.grace_interval')" :items="invoice_intervals" :error-messages="errors"></v-select>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md12>
						<ValidationProvider name="name" v-slot="{ errors, valid }">
							<form-localized-editor v-model="item.description" :errors="errors" :valid="valid">
							</form-localized-editor>
						</ValidationProvider>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4 class="pl-10">
				<v-layout row wrap>
					<v-flex xs12 md12>
						<v-card>
							<v-card-title primary-title>
								<h3>{{ $t("label.image") }}</h3>
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-file-input :rules="rules" accept="image/png, image/jpeg, image/bmp" :placeholder="$t('Choose sample card')" prepend-icon="mdi-camera" :label="$t('Sample Card')" v-model="item.sample_card"></v-file-input>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex xs12>
						<v-text-field v-model="item.active_subscribers_limit" :label="$t('label.active_subscribers_limit')" type="number"></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-switch v-model="item.active" :label="$t('Is Active')"></v-switch>
					</v-flex>
					<v-flex xs12>
						<v-switch v-model="item.is_public" :label="$t('Is Public')"></v-switch>
					</v-flex>
					<v-flex xs12>
						<v-switch v-model="item.is_flatiron" :label="$t('Is Flatiron')"></v-switch>
					</v-flex>
					<v-flex xs12>
						<v-switch v-model="item.is_nbc" :label="$t('Is NBC')"></v-switch>
					</v-flex>

					<v-flex xs12>
						<ValidationProvider name="restaurant_validity" v-slot="{ errors, valid }">
							<v-select v-model="item.restaurant_validity" :items="[
								{ text: $t('label.all'), value: 'all' },
								{
									text: $t('label.selected'),
									value: 'selected',
								},
							]" :label="$t('Tenant_validity')" item-value="value" item-text="text" :errors="errors" :valid="valid"></v-select>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider name="tenant_ids" v-slot="{ errors, valid }">
							<v-autocomplete v-show="item.restaurant_validity == 'selected'" v-model="item.tenant_ids" :items="tenants" item-value="id" item-text="name" :label="$t('Tenants')" multiple :errors="errors" :valid="valid"></v-autocomplete>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider name="outlet_validity" v-slot="{ errors, valid }">
							<v-select v-model="item.outlet_validity" :items="[
								{ text: $t('label.all'), value: 'all' },
								{
									text: $t('label.selected'),
									value: 'selected',
								},
							]" item-value="value" item-text="text" :label="$t('label.outlet_validity')" :errors="errors" :valid="valid"></v-select>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider name="outlet_validity" v-slot="{ errors, valid }">
							<v-autocomplete v-show="item.outlet_validity == 'selected'" v-model="item.outlet_ids" :items="outlets" item-value="id" item-text="outlet_name" :label="$t('label.outlets')" multiple :errors="errors"
								:valid="valid"></v-autocomplete>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider name="category_validity" v-slot="{ errors, valid }">
							<v-select v-model="item.category_validity" :items="[
								{ text: $t('label.all'), value: 'all' },
								{
									text: $t('label.selected'),
									value: 'selected',
								},
							]" :label="$t('label.category_validity')" item-value="value" item-text="text" :errors="errors" :valid="valid"></v-select>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider name="category_ids" v-slot="{ errors, valid }">
							<v-autocomplete v-show="item.category_validity == 'selected'" v-model="item.category_ids" :items="categories" item-value="id" item-text="name" :label="$t('label.categories')" multiple :errors="errors"
								:valid="valid"></v-autocomplete>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12>
						<v-switch v-model="item.show_expiry_date_on_card" :label="$t('Show Expiry Date on Card')"></v-switch>
					</v-flex>

					<v-flex xs12 md6>
						<v-text-field type="number" v-model="item.position.name.x" :label="$t('Name (x)')"></v-text-field>
					</v-flex>
					<v-flex xs12 md6>
						<v-text-field type="number" v-model="item.position.name.y" :label="$t('Name (y)')"></v-text-field>
					</v-flex>

					<v-flex xs12 md6>
						<v-text-field type="number" v-model="item.position.code.x" :label="$t('Code (x)')"></v-text-field>
					</v-flex>
					<v-flex xs12 md6>
						<v-text-field type="number" v-model="item.position.code.y" :label="$t('Code (y)')"></v-text-field>
					</v-flex>

					<v-flex xs12 md6>
						<v-text-field type="number" v-model="item.position.expiry.x" :label="$t('Expiry (x)')"></v-text-field>
					</v-flex>
					<v-flex xs12 md6>
						<v-text-field type="number" v-model="item.position.expiry.y" :label="$t('Expiry (y)')"></v-text-field>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md12>
				<v-card>
					<v-card-title primary-title>
						{{ $t("title.features") }}
						<v-spacer></v-spacer>
						<v-btn text @click="addItem">
							<v-icon left>mdi-plus</v-icon>
							{{ $t("label.add") }}
						</v-btn>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th>{{ $t("Status") }}</th>
										<th class="text-left">
											{{ $t("Name") }}
										</th>
										<th class="text-left">
											{{ $t("Type") }}
										</th>
										<th class="text-left">
											{{ $t("label.value") }}
										</th>
										<th class="text-left">
											{{ $t("label.remove") }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(
											feature, index
										) in item.features" :key="index">
										<td>
											<v-switch v-model="feature.active"></v-switch>
										</td>
										<td>{{ feature.name }}</td>
										<td>
											<ValidationProvider name="type" v-slot="{ errors }">
												<v-select :items="types" v-model="feature.type" item-value="value" item-text="text" :label="$t('label.type')" :error-messages="errors" :disabled="feature.active == false
													"></v-select>
											</ValidationProvider>
										</td>
										<td>
											<v-flex xs12 v-show="feature.type == 'percentage'
												">
												<ValidationProvider name="percentage" v-slot="{ errors }">
													<v-text-field type="number" label="Percentage" v-model="feature.percentage
														" :error-messages="errors" prepend-inner-icon="mdi-percent" :disabled="!feature.active
															"></v-text-field>
												</ValidationProvider>
											</v-flex>
											<v-flex xs12 v-show="feature.type == 'fixed'">
												<ValidationProvider name="type" v-slot="{ errors }">
													<v-text-field type="number" label="Fixed" v-model="feature.fixed" :error-messages="errors" prepend-inner-icon="mdi-cash" :disabled="!feature.active
														"></v-text-field>
												</ValidationProvider>
											</v-flex>
										</td>
										<td>
											<v-btn icon small @click="removeFeature(index)">
												<v-icon>mdi-delete</v-icon>
											</v-btn>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-dialog v-model="dialog" persistent :overlay="false" max-width="500px" transition="dialog-transition">
			<v-card>
				<v-card-title primary-title>
					{{ $t("title.add_feature") }}
					<v-spacer></v-spacer>
					<v-btn text @click="closeItem()"><v-icon left>mdi-close</v-icon>
						{{ $t("Close") }}</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-btn text v-for="(feature, index) in availableFeatures" :key="`feature-` + index" @click="addFeature(feature)">
						{{ feature }}
					</v-btn>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	export default {
		props: ["value", "tenants", "outlets", "categories", "features"],
		data() {
			return {
				invoice_intervals: [
					{
						value: "day",
						text: this.$t("label.day"),
					},
					{
						value: "week",
						text: this.$t("label.week"),
					},
					{
						value: "month",
						text: this.$t("label.month"),
					},
					{
						value: "year",
						text: this.$t("label.year"),
					},
				],
				types: [
					{
						value: "percentage",
						text: this.$t("label.percentage"),
					},
					{
						value: "fixed",
						text: this.$t("label.fixed"),
					},
				],
				dialog: false,
				rules: [
					(value) =>
						!value ||
						value.size < 2000000 ||
						"Avatar size should be less than 2 MB!",
				],
			};
		},
		computed: {
			item: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit("input", value);
				},
			},
			availableFeatures() {
				return this.features.filter(
					(feature) =>
						// find existing features in item.features
						this.item.features.findIndex(
							(itemFeature) => itemFeature.slug == feature
						) == -1
				);
			},
		},

		methods: {
			addItem() {
				this.dialog = true;
			},

			closeItem() {
				this.dialog = false;
			},

			addFeature(feature) {
				this.item.features.push({
					active: true,
					name: feature,
					slug: feature,
					type: "percentage",
					percentage: 0,
				});
			},
			removeFeature(index) {
				this.item.features.splice(index, 1);
			},
		},
	};
</script>